import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ProjectServiceCreateResponseJson } from '@vmspdb/definitions';
import * as ProjectActions from './projects.actions';

export const projectsFeatureKey = 'projects';

export type ProjectMinimal = Pick<
  ProjectServiceCreateResponseJson,
  'uuid' | 'name' | 'jobNumber' | 'managers'
>;

export interface ProjectState extends EntityState<ProjectMinimal> {
  loading: boolean;
  total: number;
  // additional entities state properties
}

export const adapter: EntityAdapter<ProjectMinimal> =
  createEntityAdapter<ProjectMinimal>({
    selectId: (model) => model.uuid || '',
  });

export const initialState: ProjectState = adapter.getInitialState({
  // additional entity state properties
  total: 0,
  loading: true,
});

export const reducer = createReducer(
  initialState,
  on(ProjectActions.listProjects, (state) => ({
    ...state,
    loading: true,
  })),
  on(ProjectActions.loadSingleProject, (state) => ({
    ...state,
    loading: true,
  })),
  on(ProjectActions.listProjectsFailure, (state, { error }) =>
    adapter.removeAll({ ...state, loading: false, error }),
  ),
  on(ProjectActions.addProject, (state, action) =>
    adapter.addOne(action.project, state),
  ),
  on(ProjectActions.upsertProject, (state, action) =>
    adapter.upsertOne(action.project, state),
  ),
  on(ProjectActions.addProjects, (state, action) =>
    adapter.addMany(action.projects, state),
  ),
  on(ProjectActions.upsertProjects, (state, action) =>
    adapter.upsertMany(action.projects, state),
  ),
  on(ProjectActions.updateProject, (state, action) =>
    adapter.updateOne(action.project, state),
  ),
  on(ProjectActions.updateProjects, (state, action) =>
    adapter.updateMany(action.projects, state),
  ),
  on(ProjectActions.deleteProject, (state, action) =>
    adapter.removeOne(action.id, state),
  ),
  on(ProjectActions.deleteProjects, (state, action) =>
    adapter.removeMany(action.ids, state),
  ),
  on(ProjectActions.loadProjects, (state, action) =>
    adapter.setAll(action.projects, state),
  ),
  on(ProjectActions.clearProjects, (state) => adapter.removeAll(state)),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const projectSelectors = adapter.getSelectors();
